import type { BreadcrumbItem } from "../components/controls/frontend-productlist/types";

export interface ITrackingInformation {
    productId: number;
    listName: string | undefined | null;
    categoryPath: string[] | undefined | null;
    breadcrumb: BreadcrumbItem[] | undefined | null;
}
export class TrackingInformation implements ITrackingInformation {
    productId: number;
    listName: string | undefined | null;
    categoryPath: string[] | undefined | null;
    breadcrumb: BreadcrumbItem[] | undefined | null;
    constructor({
        productId,
        listName,
        categoryPath,
        breadcrumb,
    }: {
        productId: ITrackingInformation["productId"];
        listName: ITrackingInformation["listName"];
        categoryPath: ITrackingInformation["categoryPath"];
        breadcrumb: ITrackingInformation["breadcrumb"];
    }) {
        this.productId = productId;
        this.listName = listName;
        this.categoryPath = categoryPath;
        this.breadcrumb = breadcrumb;
    }
}

export function storeLinkTrackingInformation(
    itemElement: Element,
    data: TrackingInformation
) {
    if (!itemElement.hasAttribute("data-productid"))
        itemElement.setAttribute("data-productid", data.productId.toString());
    itemElement.setAttribute("data-tracking-listName", data.listName ?? "");
    itemElement.setAttribute(
        "data-tracking-categoryPath",
        JSON.stringify(data.categoryPath)
    );
    if (data.breadcrumb != null && data.breadcrumb.length > 0)
        itemElement.setAttribute(
            "data-tracking-breadcrumb",
            JSON.stringify(data.breadcrumb)
        );
}

function parseJsonOrNull(content: string | null) {
    if (content == null) return null;
    return JSON.parse(content);
}

function tryGetBreadcrumbsElement(
    itemElement: Element
): BreadcrumbItem[] | undefined | null {
    // const breadcrumb =
    //     document.querySelector("[data-role='product-list-breadcrumbs']") != null
    //         ? parseJsonOrNull(
    //               itemElement.getAttribute("data-tracking-breadcrumb")
    //           )
    //         : undefined;
    // return breadcrumb;
    return undefined;
}

function getBreadcrumbsFromElement(
    itemElement: Element
): BreadcrumbItem[] | undefined | null {
    const json = itemElement.getAttribute("data-tracking-breadcrumb");
    return parseJsonOrNull(json);
}

export function extractLinkTrackingInformation(
    itemElement: Element
): TrackingInformation {
    const productIdString = itemElement.getAttribute("data-productid");
    if (productIdString == null) throw new Error("ProductId not found");
    const productId = parseInt(productIdString);
    const listName = itemElement.getAttribute("data-tracking-listName");
    const categoryPath = parseJsonOrNull(
        itemElement.getAttribute("data-tracking-categoryPath")
    );
    return new TrackingInformation({
        productId,
        listName,
        categoryPath,
        breadcrumb:
            getBreadcrumbsFromElement(itemElement) ??
            tryGetBreadcrumbsElement(itemElement),
    });
}
